import { useDraggable } from '@dnd-kit/core';
import './ComponentPanel.css';

const DraggableComponent = ({ id, type, icon, label }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `${id}_${Date.now()}`,
    data: { 
      type,
      fieldType: type,
      source: 'component-panel'
    }
  });
  
  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
  } : undefined;

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`hvnly--builder--int_api__property_builder_component_item ${isDragging ? 'hvnly--builder--int_api__dragging' : ''}`}
      {...listeners}
      {...attributes}
    >
      <i className={`fas fa-${icon}`}></i>
      <span>{label}</span>
    </div>
  );
};

export default DraggableComponent;